<template>
    <div class="sys-notes">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'AppNotes'
}
</script>


// WEBPACK FOOTER //
// src/components/AppNotes/index.vue